module.exports = __webpack_public_path__ + "img/소비자욕구파악아이콘.b260f0c8.png";